import { Typography, Tooltip } from "@mui/material";

const PageTitle = (props) => {
  const { title, variant = "h4", truncate = false, maxWidth = "300px", ...otherProps } = props;

  if (truncate) {
    return (
      <Tooltip title={title} arrow>
        <Typography
          variant={variant}
          component={variant}
          gutterBottom
          fontWeight={600}
          m={0}
          sx={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            maxWidth: maxWidth,
            ...props.sx,
          }}
          {...otherProps}
        >
          {title}
        </Typography>
      </Tooltip>
    );
  }

  return (
    <Typography
      variant={variant}
      component={variant}
      gutterBottom
      fontWeight={600}
      m={0}
      {...props}
    >
      {title}
    </Typography>
  );
};

export default PageTitle;
